import { DatePipe, formatDate } from '@angular/common'
import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { GlobalMessageType, RoutingService, TranslationService } from '@spartacus/core'
import { OrderHistoryComponent } from '@spartacus/order/components'
import { OrderHistoryFacade, OrderHistoryList, ReplenishmentOrderHistoryFacade } from '@spartacus/order/root'
import { ngxCsv } from 'ngx-csv'
import { Observable, combineLatest } from 'rxjs'
import { finalize, map } from 'rxjs/operators'
import { CustomRoutes } from '../../../models/enum/custom-routes.enum'
import { OrderLineStatus, OrderStatus } from '../../../models/enum/order.enum'
import { OrderDocumentType } from '../../../models/enum/orderDocument.enum'
import { SharedValue } from '../../../models/enum/shared.enum'
import { ErrorMessage } from '../../../models/error.model'
import { ICustomOrderHistory, OrderDocumentsNumber } from '../../../models/interface/order-history-interface'
import { ICustomOrderHistoryList } from '../../../models/orderHistoryList.model'
import { DocumentService } from '../../../services/document.service'
import { OrderHistoryService } from '../../../services/order-history.service'
import { CustomOrderHistoryService } from '../../../services/order/custom-order-history.service'
import { CustomGlobalMessageService } from '../../../services/shared/custom-global-message/custom-global-message.service'
import { SharedService } from '../../../services/shared/shared.service'
import { UserPermissionService } from '../../../services/user-permission/user-permission.service'
import { ConfirmModalComponent, DataConfirmModal } from '../../shared/confirm-modal/confirm-modal.component'
import { ICustomSelectOption } from '../../shared/custom-components/custom-select/modals/interface/custom-select.interface'

@Component({
  selector: 'app-custom-order-history',
  templateUrl: './custom-order-history.component.html',
  styleUrls: ['./custom-order-history.component.scss'],
  standalone: false
})
export class CustomOrderHistoryComponent extends OrderHistoryComponent implements OnInit {
  [x: string]: any
  constructor(
    protected routing: RoutingService,
    protected translation: TranslationService,
    public orderHistoryService: OrderHistoryService,
    public globalMessageService: CustomGlobalMessageService,
    public changeDetectorRef: ChangeDetectorRef,
    private documentService: DocumentService,
    private sharedService: SharedService,
    public userPermissionService: UserPermissionService,
    public datepipe: DatePipe,
    public routingService: RoutingService,
    orderHistoryFacade: OrderHistoryFacade,
    replenishmentOrderHistoryFacade: ReplenishmentOrderHistoryFacade,
    private customOrderHistoryService: CustomOrderHistoryService
  ) {
    super(routing, orderHistoryFacade, translation, replenishmentOrderHistoryFacade)
  }

  public sortOptions: ICustomSelectOption[] = [
    { label: 'shared.sort.byDate', value: 'byDate' },
    { label: 'shared.sort.byOrderNumber', value: 'byOrderNumber' },
    { label: 'shared.sort.byStatus', value: 'byStatus' }
  ]

  public spinner = false
  public showSpinnerOnDataLoad = false
  public spinnerOnReorder: any = {}
  public errorMessage: ErrorMessage = new ErrorMessage()

  public selectedPage: number

  private readonly SIZE: number = 5

  public selectedFilter: string = null
  public selectedLineFilter: string = null
  public filters = Object.values(OrderStatus)
  public linestatusFilters = Object.values(OrderLineStatus)

  public inputSearch: string
  public noOrders?: boolean
  public downloadSpinner: boolean = false

  ngOnInit(): void {
    this.sharedService
      .getQueryParams()
      .subscribe((queryParams) => {
        if (queryParams?.page) {
          this.pageChange(queryParams.page)
        } else {
          this.pageChange(1)
        }
      })
      .unsubscribe()
  }

  changeSortCode(sortCode: string): void {
    this.sortType = sortCode
    this.inputSearch = null

    const params: ICustomOrderHistory = {
      currentPage: 0,
      sortCode: this.sortType,
      pageSize: this.SIZE,
      filterId: this.selectedFilter ? this.selectedFilter : this.selectedLineFilter,
      isLinefilter: this.selectedFilter ? 'false' : 'true'
    }

    // TODO:Spartacus - The type of property 'orders$: Observable<OrderHistoryList>' changed to: 'orders$: Observable<OrderHistoryList | undefined>'
    this.orders$ = this.getOrderHistory(params)
  }

  pageChange(page: number): void {
    // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
    this.routingService.go(
      {
        cxRoute: CustomRoutes.ORDER_HISTORY
        // }, null, {queryParams: {page: page}});
      },
      { queryParams: { page: page } }
    )

    this.selectedPage = page
    const params: ICustomOrderHistory = {
      currentPage: this.selectedPage,
      sortCode: this.sortType,
      pageSize: this.SIZE,
      filterId: this.selectedFilter ? this.selectedFilter : this.selectedLineFilter,
      isLinefilter: this.selectedFilter ? 'false' : 'true'
    }
    // TODO:Spartacus - The type of property 'orders$: Observable<OrderHistoryList>' changed to: 'orders$: Observable<OrderHistoryList | undefined>'
    this.orders$ = this.getOrderHistory(params)
  }

  public getFilteredOrders(filteredId: string): void {
    this.selectedFilter = filteredId
    this.selectedLineFilter = null

    const params: ICustomOrderHistory = {
      sortCode: this.sortType,
      pageSize: this.SIZE,
      filterId: filteredId,
      isLinefilter: 'false'
    }
    // TODO:Spartacus - The type of property 'orders$: Observable<OrderHistoryList>' changed to: 'orders$: Observable<OrderHistoryList | undefined>'
    this.orders$ = this.getOrderHistory(params)
  }

  public getFilteredLineOrders(filteredId: string): void {
    this.inputSearch = null
    this.selectedFilter = null
    this.selectedLineFilter = filteredId

    const params: ICustomOrderHistory = {
      sortCode: this.sortType,
      pageSize: this.SIZE,
      filterId: filteredId,
      isLinefilter: 'true'
    }
    // TODO:Spartacus - The type of property 'orders$: Observable<OrderHistoryList>' changed to: 'orders$: Observable<OrderHistoryList | undefined>'
    this.orders$ = this.getOrderHistory(params)
  }

  private getOrderHistory(params: ICustomOrderHistory): Observable<OrderHistoryList> {
    this.showSpinnerOnDataLoad = true
    return this.orderHistoryService.getOrdersHistory(params).pipe(
      finalize(() => {
        this.showSpinnerOnDataLoad = false
      })
    )
  }

  public detailViewClicked(orderCode): void {
    // },null,{queryParams: {distributorNo: value?.distributorNo}}

    sessionStorage.setItem('orderCode', JSON.stringify(orderCode))

    const queryParam = {
      // [CustomRoutes.ORDER_HISTORY]: { page: this.selectedPage }
      [CustomRoutes.ORDER_HISTORY]: { page: this.selectedPage }
    }
    this.sharedService.setQueryParamsLocal(queryParam)

    this.routingService.go({
      cxRoute: CustomRoutes.ORDER_DETAIL,
      params: { code: orderCode }
    })
  }

  //   public viewDetails(value: any): void {

  // 	  const queryParam = {
  // 		  [CustomRoutes.CREDIT_CLAIMS]: {page: this.selectedPage}
  // 	  };
  // 	  this.sharedService.setQueryParamsLocal(queryParam);

  // // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
  //     this.routingService.go({
  //       cxRoute: CustomRoutes.CREDIT_CLAIM_DETAILS,
  //       params: {code: value?.creditClaimCode}
  //       // Sagar
  //     // },null,{queryParams: {distributorNo: value?.distributorNo}}
  //     }, {queryParams: {distributorNo: value?.distributorNo}}
  //     );
  //   }

  public orderAgain(orderCode: string): void {
    combineLatest([
      this.translation.translate('modals.orderAgain.title'),
      this.translation.translate('modals.orderAgain.msg'),
      this.translation.translate('modals.orderAgain.extra'),
      this.translation.translate('modals.orderAgain.yes')
    ]).subscribe(([title, msg, extra, yes]) => {
      const dataModal: DataConfirmModal = { title, msg, extra, yes }
      this.sharedService.showConfirmModal(ConfirmModalComponent, dataModal).then((ok) => {
        if (!ok) {
          return
        }

        this.spinnerOnReorder[orderCode] = true
        this.changeDetectorRef.detectChanges()

        this.orderHistoryService
          .orderAgain(orderCode)
          .pipe(
            finalize(() => {
              this.spinnerOnReorder[orderCode] = false
              this.changeDetectorRef.detectChanges()
            })
          )
          .subscribe(
            () => {
              this.routing.goByUrl('cart')
            },
            () => {
              this.globalMessageService.add({ key: 'shared.error.orderAgain' }, GlobalMessageType.MSG_TYPE_ERROR)
            }
          )
      })
    })
  }

  public showSpinnerOnReorder(reorderCode): boolean {
    return this.spinnerOnReorder[reorderCode]
  }

  getSortLabels(): Observable<{ byDate: string; byOrderNumber: string }> {
    return combineLatest([
      this.translation.translate('shared.sort.byDate'),
      this.translation.translate('shared.sort.byOrderNumber'),
      this.translation.translate('shared.sort.byStatus')
    ]).pipe(
      map(([textByDate, textByOrderNumber, textByStatus]) => {
        return {
          byDate: textByDate,
          byOrderNumber: textByOrderNumber,
          byStatus: textByStatus
        }
      })
    )
  }

  public onDocumentClicked(orderDocumentsNumber: OrderDocumentsNumber): void {
    if (orderDocumentsNumber.documentNumber) {
      const documentNumber: string = orderDocumentsNumber.documentNumber
      if (orderDocumentsNumber?.documentType === 'Invoice') {
        this.documentService.generateOrderDocument(documentNumber, OrderDocumentType.INVOICE)
      } else {
        this.documentService.generateOrderDocument(documentNumber, OrderDocumentType.CREDITNOTE)
      }
    }

    // this.documentService.getDocumentByNumber(documentNumber).subscribe((data: OrderDocument) => {
    //   data = this.sampleOrderDucumentInvoice;

    //  // [TODO] consume this response and pass it to generate document service to produce document HTML
    //  // get the HTML and invoke create PDF library to get PDFand save it to browser for download
    // });
  }

  public searchOrder(code: string): void {
    code = code?.trim()

    if (code) {
      // TODO:Spartacus - The type of property 'orders$: Observable<OrderHistoryList>' changed to: 'orders$: Observable<OrderHistoryList | undefined>'
      this.orders$ = this.getOrderHistory({ code })
    } else {
      const params: ICustomOrderHistory = {
        currentPage: 0,
        sortCode: this.sortType,
        filterId: this.selectedFilter ? this.selectedFilter : this.selectedLineFilter,
        isLinefilter: this.selectedFilter ? 'false' : 'true'
      }
      // TODO:Spartacus - The type of property 'orders$: Observable<OrderHistoryList>' changed to: 'orders$: Observable<OrderHistoryList | undefined>'
      this.orders$ = this.getOrderHistory(params)
    }
  }

  public checkCreditClaim(orderDocumentsNumber?: string[]): boolean {
    return this.orderHistoryService.checkOrderCreditClaim(orderDocumentsNumber)
  }

  public onDownloadCSV(): void {
    this.downloadSpinner = true
    this.changeDetectorRef.detectChanges()
    this.orderHistoryService.getOrderHistoryCsv(this.selectedFilter).subscribe(
      (orderHistoryList: ICustomOrderHistoryList) => {
        if (orderHistoryList && orderHistoryList.orders) {
          this.changeDetectorRef.detectChanges()
          this.generateOrderHistoryListCSV(orderHistoryList.orders)
          this.downloadSpinner = false
        } else {
          this.changeDetectorRef.detectChanges()
          this.globalMessageService.add(SharedValue.noOrdersAvailable, GlobalMessageType.MSG_TYPE_ERROR)
          this.downloadSpinner = false
        }
      },
      () => {
        this.globalMessageService.add(SharedValue.errorTryAgain, GlobalMessageType.MSG_TYPE_ERROR)
      }
    )
  }

  public generateOrderHistoryListCSV(orders: ICustomOrderHistory[]) {
    const data: any[] = []
    orders.forEach((order) => {
      let orderDetails: any
      order.entries.forEach((orderEntry) => {
        orderDetails = {
          productName: order?.code ? order.code : '',
          OrderDate: order?.placed ? this.datepipe.transform(order.placed, 'dd-MM-yyyy') : '',
          purchaseOrderNumber: order?.purchaseOrderNumber ? order.purchaseOrderNumber : '',
          status: order?.statusDisplay ? order?.statusDisplay : '',
          total: order?.total ? order?.total.formattedValue : '',
          shipTo: orderEntry?.shipTo ? orderEntry?.shipTo : '',
          productNumber: orderEntry?.sku ? orderEntry?.sku : '',
          productShortDescription: orderEntry?.skuName ? orderEntry.skuName : '',
          unitPrice: orderEntry?.price ? orderEntry.price : '',
          eta: orderEntry?.eta ? orderEntry.eta : '',
          LineStatus: orderEntry?.lineStatus ? orderEntry.lineStatus : '',
          orderedQuantity: orderEntry.orderedQuantity ? orderEntry.orderedQuantity : '',
          deliveredQuantity: orderEntry.deliveredQuantity ? orderEntry.deliveredQuantity : ''
        }
        data.push(orderDetails)
      })
    })
    const todayDate = formatDate(new Date(), 'MMMM d, y', 'en')
    const fileName = 'Order history_' + todayDate
    const options = {
      title: 'Order history: ' + todayDate,
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      useBom: true,
      headers: [
        'ORDER #',
        'Order Date',
        'PO #',
        'Order Status',
        'Total',
        'Ship to',
        'Product Number',
        'Product Short Description',
        'Unit Price',
        'ETA Date',
        'Line Status',
        'Ordered quantity',
        'Delivered Quantity'
      ]
    }
    new ngxCsv(data, fileName, options)
  }

  public checkSubmitClaim(order: any): boolean {
    if (null != order?.entries) {
      for (const entry of order?.entries) {
        if (entry?.lineStatus === 'Delivered' || entry?.lineStatus === 'Completed') {
          return true
        }
      }
    }
    return false
  }
}
